import React from "react";
import { HI, HiInfo, DetailsWrapper, InfoWrapper, LogoWrapper, NameWrapper, ButtonWrapper } from "./CandidateInterview.styled";
import { Button, Icon, Tag } from "maui";
import logo from "../../assets/svgs/findem_logo.svg";
import { IInterviewCandidate, IInterviewRound, IInterviewSpec, IInterviewStage } from "../../types/calendar";
import { DefaultTheme } from "styled-components";
import { useSelector } from "react-redux";

interface IInterviewInfoProps {
  spec?: IInterviewSpec;
  goToSchedule: () => void;
  candidateName?: string;
  logoUrl?: string | undefined;
  themeColor?: string;
  interviewCandidate?: IInterviewCandidate;
}


const InterviewInfo: React.FC<IInterviewInfoProps> = ({ spec, goToSchedule, candidateName, logoUrl, interviewCandidate, themeColor }) => {
  
  const firstStage: IInterviewStage | undefined = React.useMemo(() => spec ? spec.stages[0] : undefined, [spec]);
  const [selectedStage, setSelectedStage] = React.useState<IInterviewStage | undefined>(firstStage);

  const themeC: DefaultTheme = useSelector((state: any) => state.appState.theme);

  const stagesCount: number = React.useMemo(() => (selectedStage ? [selectedStage] : []).reduce((acc, stage) => acc + stage.interview_round.length, 0), [selectedStage]);
  const totalDuration: number = React.useMemo(() => (selectedStage ? [selectedStage] : []).reduce((acc, stage) => acc + stage.interview_round.reduce((acc, round) => acc + (round.schedule?.duration_minutes || 30), 0), 0), [selectedStage]);

  const allRounds: IInterviewRound[] = React.useMemo(() =>{
    const rounds: IInterviewRound[] = [];
    (selectedStage ? [selectedStage] : []).forEach((stage) => {
      rounds.push(...stage.interview_round);
    });
    return rounds;
  }, [selectedStage]);

  React.useEffect(() => {
    if(interviewCandidate && spec){
      const currentStageIdx: string = interviewCandidate.stage_idx || '0';
      const _stages: IInterviewStage[] = spec.stages;
      const _currentStage: IInterviewStage | undefined = _stages.find((stage: IInterviewStage) => stage._id === currentStageIdx);
      if(_currentStage){
        setSelectedStage(_currentStage);
      }
    }
  },[interviewCandidate, spec]);
  return (<>
    <InfoWrapper>
      <LogoWrapper><img src={logoUrl || logo} alt="findem-logo"/></LogoWrapper>
      <NameWrapper>
        <HI>Hi{candidateName ? ` ${candidateName} ` : ''}👋 Excited to meet you!</HI>
        <HiInfo>Let’s find a good time to meet.</HiInfo>
      </NameWrapper>
      {selectedStage && <DetailsWrapper>
        <div>
          <HI>Your Interview</HI>
          <HiInfo>{totalDuration} mins total time with {stagesCount} events</HiInfo>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', gap: 4}}>
          {allRounds.map((round, index) => (
            <div key={index}>
              <Tag style={{color: themeC.colors['blue-400'], backgroundColor: themeC.colors['blue-200']}}>
                <Icon icon="schedule" style={{
                  position: 'relative',
                  top: '2px',
                  marginRight: '4px',
                }}/>
                {round.schedule?.duration_minutes || 30} mins
              </Tag>
              {round.name}
            </div>)
          )}
        </div>
      </DetailsWrapper>}
      <ButtonWrapper>
        <Button 
          style={{marginTop: 32, 
            color: themeC.colors['white'], 
            backgroundColor: themeC.colors['blue-400'],
            borderColor: themeC.colors['blue-400'],
          }} onClick={goToSchedule}>Get Started</Button>
      </ButtonWrapper>
    </InfoWrapper>
  </>);
};

export default InterviewInfo;